import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { connect, DispatchProp } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

import Color from 'src/assets/_util.scss';
import { HStack } from 'src/components/core/Stack';
import { Catalog } from 'src/types/insights';

import styles from './CatalogCard.module.scss';

interface BaseProps {
  catalog: Catalog;
}

type Props = BaseProps & DispatchProp;

const CatalogCard: React.FunctionComponent<Props> = (props: Props) => {
  const { catalog } = props;
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <Card
      key={catalog.id}
      className={styles.editCatalogCard}
      data-testid="EditCatalogCard"
      onClick={() => {
        history.push(`/insights/catalog/${catalog.id}`);
      }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '12px',
        cursor: 'pointer',
        p: '20px',
        maxWidth: '648px',
      }}
    >
      <CardHeader
        sx={{ p: 0 }}
        title={
          <HStack sx={{ alignItems: 'center', gap: 1 }}>
            <Typography component="h3" variant="h6" className="lh-1">
              {catalog.title}
            </Typography>
            {catalog.mobile && <MobileCatalogChip />}
          </HStack>
        }
      />
      {catalog.description && catalog.description.length > 0 && (
        <CardContent style={{ padding: '8px 0 0' }}>
          <Typography component="p">{catalog.description}</Typography>
        </CardContent>
      )}
    </Card>
  );
};

export default connect()(CatalogCard);

export function MobileCatalogChip() {
  const { t } = useTranslation();
  return (
    <Tooltip
      arrow
      data-testid="mobile-catalog-tooltip"
      placement="bottom"
      title={t('insights.mobile_catalog_tooltip')}
    >
      <Chip
        component="span"
        data-testid="mobile-catalog-chip"
        label={t('insights.mobile_catalog')}
        size="small"
        sx={{
          border: `1px solid ${Color.foraPurple}`,
          color: Color.foraPurple,
          width: 'min-content',
          fontWeight: 600,
        }}
        variant="outlined"
      />
    </Tooltip>
  );
}
